import { ObjectValues } from "@/src/shared/types/objectValues";

export const DS_SIZE = {
  ExtraSmall: "xs",
  Small: "sm",
  Medium: "md",
  Large: "lg",
  ExtraLarge: "xl",
} as const;

export type DSSize = ObjectValues<typeof DS_SIZE>;
